/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useMemo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box, IconButton, Tooltip } from '@mui/material';
import {
  MaterialReactTable,
  useMaterialReactTable,
} from 'material-react-table';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';

import { ReactComponent as Edit } from 'src/assets/icons/edit.svg';
import CustomInput, {
  ConsultaInput,
  SelectInput,
  SelectInput2,
} from '../customInput';
import SearchTable from './searchTable';
import LixeiraTable from './lixeiraTable';

import { ReactComponent as Delete } from 'src/assets/icons/trash.svg';
import { ReactComponent as SaveIcon } from 'src/assets/icons/save.svg';
import { ReactComponent as GoBack } from 'src/assets/icons/goBack.svg';
import { ReactComponent as Lock } from 'src/assets/icons/lock.svg';
import { ReactComponent as Check } from 'src/assets/icons/check.svg';
import { ReactComponent as End } from 'src/assets/icons/end.svg';
import { ReactComponent as ShowTodos } from 'src/assets/icons/restore.svg';
import { ReactComponent as Plug } from 'src/assets/icons/plug.svg';
import { ReactComponent as Plugged } from 'src/assets/icons/plugged.svg';
import { ReactComponent as Divide } from 'src/assets/icons/divide.svg';
import DefIcon from 'src/assets/base/page.svg';

import showToast from '../toastyService';
import { GetProcesso, isValid, transformResponse } from 'src/services/auth';
import { isDark } from '../DetectBrightness';
import CentroDeCusto from '../rateios/centroDeCusto';

export default function SubFormTable({
  colunas,
  saveFunction,
  block,
  titulo,
  extraData,
  extraExtraData,
  OnClose,
  id,
  tabIndex,
  corFundo,
  blockAdd,
  myData,
  formData,
}) {
  const [subformForm, setSubformForm] = useState({});
  const [lixeira, setLixeira] = useState([]);

  const [buttons, setButtons] = useState([]);

  const [centroDeCustos, setCentroDeCustos] = useState(false);

  const [formError, setFormError] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  const [rowToDelete, setRowToDelete] = useState({});

  const [tableData, setTableData] = useState([]);
  const [data, setData] = useState([]);

  const abas = colunas?.abas?.map((aba) => aba.nome);
  const [showAbaTodos, setShowAbaTodos] = useState(false);
  const contrastColor = isDark(corFundo);
  const [chooseAba, setChooseAba] = useState('');

  const [acoes, setAcoes] = useState({});
  const [consultaAcao, setConsultaAcao] = useState(false);
  const [acaoParametros, setAcaoParametros] = useState({});
  const [acaoParametrosResult, setAcaoParametrosResult] = useState({});
  const [thisAcaoName, setThisAcaoName] = useState('');

  const thisBlock = false;
  const blockReg = false;

  const isAdm =
    localStorage.getItem('IsAdm') === 'S' ||
    localStorage.getItem('IsAdm') === true;

  useEffect(() => {
    setConsultaAcao(false);
  }, [chooseAba]);

  useEffect(() => {
    const revertTransformedData = (data) => {
      if (typeof data !== 'object' || data === null) return []; // Verifica se é um objeto não nulo

      // Para cada chave no objeto, remove os índices e cria um novo objeto
      return Object.entries(data)
        .filter(([key]) => key.toLowerCase().includes(id.toLowerCase())) // Filtra apenas os itens desejados
        .map(([key, value]) => {
          const cleanKey = key.replace(/\(\d+\)$/, '');
          return { [cleanKey]: value };
        });
    };

    const revertedData = revertTransformedData(extraData);

    // Se tipAca for 'R', move para lixeira; caso contrário, adiciona a tableData
    const { tableDataItems, lixeiraItems } = revertedData.reduce(
      (acc, item) => {
        if (item[id] && item[id]?.tipAca === 'R') {
          acc.lixeiraItems.push(item);
        } else {
          acc.tableDataItems.push(item);
        }
        return acc;
      },
      { tableDataItems: [], lixeiraItems: [] }
    );

    // Adiciona os dados ao tableData e lixeira, conforme o caso
    const mergedData = [...tableDataItems];

    if (
      mergedData[0] &&
      mergedData[0][id] &&
      Object.values(mergedData[0][id]).some(
        (value) => value && typeof value === 'object' && !Array.isArray(value)
      )
    ) {
      console.log('NÂO NORMALIZA');
      setTableData(mergedData);
    } else {
      console.log('NORMALIZA');
      const normalized = mergedData[0]?.[id] ? { 0: mergedData[0][id] } : {};
      setTableData([{ [id]: normalized }]);
    }

    setLixeira(lixeiraItems); // Atualiza a lixeira com os itens que tinham tipAca igual a 'R'

    setChooseAba(isValid(abas) ? abas[0] : '');

    if (isValid(colunas?.acoes)) setAcoes(colunas.acoes);
  }, [extraData]);

  //Compila os dados da tabela ao iniciar
  useEffect(() => {
    const formatData = tableData.map((item) => {
      const entriesObj = Object.values(item)[0];
      return Object.values(entriesObj).reduce((acc, p, i) => {
        acc[`${id}${i}`] = p;
        return acc;
      }, {});
    });

    const transformedData = formatData
      .flatMap((item) => Object.values(item))
      .filter((item) => item?.tipAca !== 'R');

    setData(transformedData);
  }, [tableData]);
  //----------------------------------------------

  const columns = useMemo(() => {
    if (!colunas || typeof colunas !== 'object') return [];

    const excludeKeys = [
      'titulo',
      'endpoint',
      'relatorios',
      'repete',
      'downloadupload',
      'gridsalvar',
      'griddeletar',
      'rateio',
      'rateiovalor',
      'corfundo',
      'abas',
    ];

    return (
      Object.entries(colunas)
        // eslint-disable-next-line no-unused-vars
        .filter(([key, _]) => !excludeKeys.includes(key))
        .map(([key, item]) => ({
          accessorKey: key,
          header: item?.nome || key,
        }))
    );
  }, [colunas]);

  const [modo, setModo] = useState('');
  const [showAdd, setShowAdd] = useState(false);
  const [showLixeira, setShowLixeira] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const [selectedRateio, setSelectedRateio] = useState(null);

  const HandleEdit = (rowData) => {
    //setSubformForm();
    setModo('edit');
    setSubformForm(rowData.original);

    setSelectedRow(rowData.original);
    setShowAdd(true);
  };

  const handleClose = () => {
    setModo('');
    setFormError(false);
    setShowAdd(false);
    setSubformForm({});
    setSelectedRow(null);
  };

  function HandleAcao(botaoAcao) {
    setThisAcaoName(botaoAcao.nome);
    setAcaoParametrosResult({});

    const parametros = {};

    Object.entries(botaoAcao).forEach(([key, value]) => {
      if (
        typeof value === 'object' &&
        value !== null &&
        !Array.isArray(value)
      ) {
        parametros[key] = value;
      }
    });

    setAcaoParametros(() => ({
      ...{ config: botaoAcao },
      ...parametros,
    }));

    if (isValid(parametros)) {
      setConsultaAcao(true);
    } else {
      HandleAcaoConsulta();
    }
  }

  function HandleAcaoConsulta() {
    const config = acaoParametros.config;

    GetProcesso(config.porta, acaoParametrosResult, true, true)
      .then((res) => {
        const raw = transformResponse(res, 'result');

        const results = raw[0].children.filter((item) => {
          return (
            isValid(item.value) && item.value !== '0' && item.value !== '0.0'
          );
        });

        const convertArrayToObject = (arr) => {
          const obj = {};

          arr.forEach((item) => {
            if (item.name && item.value != null) {
              if (item.name === 'tipRet') obj[thisAcaoName] = item.value;
              else obj[item.name] = item.value;
            }
          });

          return obj;
        };

        const finalResults = convertArrayToObject(results);

        setSubformForm((prev) => ({
          ...prev,
          ...finalResults,
        }));
      })
      .catch((error) => {
        showToast('error', error);
      })
      .finally(() => {
        setConsultaAcao(false);
      });
  }

  const subFormTable = useMaterialReactTable({
    columns,
    data,
    initialState: { showGlobalFilter: true, density: 'compact' },

    enableRowSelection: true,
    enableColumnOrdering: false,
    enableGlobalFilter: true,
    enableSorting: false,
    enablePagination: true,
    paginationDisplayMode: 'pages',
    enableBottomToolbar: true,
    enableTopToolbar: true,
    enableEditing: true,
    enableStickyHeader: true,
    enableStickyFooter: true,
    rowPinningDisplayMode: 'top-and-bottom',
    enableFullScreenToggle: false,

    muiToolbarAlertBannerProps: {
      sx: {
        backgroundColor: 'transparent',
        color: '#146b7c',
      },
    },

    muiTableContainerProps: {
      sx: {
        flex: 1,
        height: '100%',
        width: '100%',
        maxHeight: 'calc(100% - 6.5rem)',
        overflow: 'auto',
      },
    },

    muiTablePaperProps: {
      sx: {
        boxShadow: 'none',
      },
    },

    muiTableBodyRowProps: ({ row }) => ({
      sx: {
        backgroundColor: row.original.bloreg === 'S' ? '#e8e8e8' : 'inherit',
        opacity: row.original.bloreg === 'S' ? '0.7' : 'inherit',
        pointerEvents: row.original.bloreg === 'S' ? 'none' : 'inherit',
      },
    }),

    renderRowActions: ({ row }) => {
      const checkBloreg = row.original.bloreg ? row.original.bloreg : '';
      return checkBloreg === 'S' ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
          <Lock className="tableIcon" title="Registro bloqueado." />
        </Box>
      ) : (
        <Box className="ActionSlot" sx={{ display: 'flex', gap: '1rem' }}>
          <Tooltip title="Editar">
            <IconButton
              className="ActionButton"
              onClick={() => HandleEdit(row)}
            >
              <Edit className="tableIcon" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Deletar">
            <IconButton
              className="ActionButton"
              onClick={() => {
                setShowWarning(true);
                setRowToDelete(row);
                /*HandleDelete(row)*/
              }}
            >
              <Delete className="tableIcon" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Rateio">
            <IconButton
              className="ActionButton"
              onClick={() => {
                setCentroDeCustos(true);
                setSelectedRateio(row);
              }}
            >
              <Divide className="tableIcon" />
            </IconButton>
          </Tooltip>
        </Box>
      );
    },

    localization: MRT_Localization_PT_BR,
  });

  const [consultaModal, setConsultaModal] = useState(null);
  const [consultaData, setConsultaData] = useState(null);
  const [consultaTitulo, setConsultaTitulo] = useState(null);

  const [itemsObrigatorios, setItemsObrigatorios] = useState([]);

  function HandleAddItem() {
    const obj = {
      tipAca: 'I',
      ...Object.keys(subformForm).reduce((acc, key) => {
        acc[key] = subformForm[key];
        return acc;
      }, {}),
      codemp: subformForm?.codemp || extraExtraData?.codemp,
      codfil: subformForm?.codfil || extraExtraData?.codfil,
    };

    const checkItemsObrigatorios = itemsObrigatorios.every((itemName) => {
      return obj[itemName] && obj[itemName] !== '';
    });

    if (!checkItemsObrigatorios) {
      setFormError(true);
      return;
    }

    setTableData((prevData) => {
      return prevData.map((item) => {
        if (item[id]) {
          const nextIndex = Object.keys(item[id]).length.toString();
          return {
            ...item,
            [id]: {
              ...item[id],
              [nextIndex]: obj,
            },
          };
        }
        return item;
      });
    });

    //Fecha
    setShowAdd(false);
    setSubformForm({});
  }

  function HandleEditItem() {
    /*const updatedTableData = tableData.map((row) => {
      if (row[id] === selectedRow) {
        return {
          [id]: {
            ...subformForm,
            tipAca: modo === 'edit' ? 'A' : subformForm.tipAca,
          },
        };
      }
      return row;
    });*/

    const updatedTableData = tableData.map((item) => ({
      ...item,
      [id]: Object.fromEntries(
        Object.entries(item[id]).map(([key, subitem]) => {
          if (subitem === selectedRow) {
            return [
              key,
              {
                ...subformForm,
                tipAca: modo === 'edit' ? 'A' : subformForm?.tipAca,
              },
            ];
          }
          return [key, subitem];
        })
      ),
    }));

    setTableData(updatedTableData);
    setShowAdd(false);
    setSubformForm({});
  }

  function HandleSave() {
    if (!block) {
      if (!Object.entries(tableData[0][id]).length > 0) {
        OnClose();
        return;
      }

      const transformedData = tableData.reduce((acc, item, index) => {
        const key = Object.keys(item)[0];

        const value = item[key];

        acc[`${id}(${index})`] = value;

        return acc;
      }, {});

      saveFunction(transformedData);
    } else {
      OnClose();
    }
  }

  function HandleSaveRateio(acao, thisData, row) {
    const updatedTableData = tableData.map((item) => ({
      ...item,
      [id]: Object.fromEntries(
        Object.entries(item[id]).map(([key, subitem], index) => {
          if (index === selectedRateio.index) {
            return [
              key,
              {
                ...subitem,
                rateio: thisData.rateio,
              },
            ];
          }
          return [key, subitem];
        })
      ),
    }));

    setTableData(updatedTableData);
    setCentroDeCustos(false);
    return;
  }

  function HandleDelete(row) {
    if (!block) {
      const updatedTableData = tableData.map((item) => ({
        ...item,
        [id]: Object.fromEntries(
          Object.entries(item[id]).map(([key, subitem], index) => {
            if (index === row.index) {
              return [
                key,
                {
                  ...subitem,
                  tipAca: 'R',
                },
              ];
            }
            return [key, subitem];
          })
        ),
      }));

      setTableData(updatedTableData); // Atualiza o estado de tableData
    }
  }

  function HandleRestore(row) {
    const updatedRow = row.map((item) => ({
      ...item,
      [id]: {
        ...item.lotesEntrada,
        tipAca: row[0][id].OLDtipAca,
      },
    }));
    setTableData([...tableData, ...updatedRow]);

    showToast('warning', 'Item Restaurado');
  }

  useEffect(() => {
    const obrigatorios = Object.entries(colunas || {})
      // eslint-disable-next-line no-unused-vars
      .filter(([_, item]) => item.obrigatorio === 'S')
      .map(([key]) => key);

    setItemsObrigatorios(obrigatorios);
  }, [colunas]);

  const formatData = (data) => {
    const [dataAno, dataMes, dataDia] = data.split('-');
    return `${dataDia}/${dataMes}/${dataAno}`;
  };

  const handleSetSearch = (data) => {
    setConsultaModal(false);
    setConsultaData(null);

    setSubformForm((prev) => ({
      ...prev,
      ...data,
    }));

    getButtons();
  };

  useEffect(() => {
    getButtons();
  }, [subformForm, chooseAba]);

  function getButtons() {
    const groupedButtons = {};

    columns.forEach((column) => {
      const key = column.accessorKey;
      const item = colunas[key];
      if (!item) return;

      const grupo =
        item.Grupo && item.Grupo !== '' ? item.Grupo : '__semgrupo__';
      if (!groupedButtons[grupo]) groupedButtons[grupo] = [];
      groupedButtons[grupo].push({ column, item, key });
    });

    setButtons(
      Object.entries(groupedButtons).map(([grupo, items]) => {
        const groupContent = items.map(({ column, item, key }) => {
          let tipo = 'text';
          switch (item.tipo) {
            case 'string':
              tipo = 'text';
              break;
            case 'integer':
            case 'float':
              tipo = 'number';
              break;
            case 'date':
              tipo = 'date';
              break;
            case 'webservice':
              tipo = 'consulta';
              break;
            case 'select':
              tipo = 'select';
              break;
            case 'select2':
              tipo = 'select2';
              break;
            default:
              tipo = 'text';
              break;
          }

          const defaultInput =
            tipo !== 'consulta' && tipo !== 'select' && tipo !== 'select2';

          const excludeKeys = [
            'titulo',
            'endpoint',
            'relatorios',
            'acoes',
            'repete',
            'downloadupload',
            'gridsalvar',
            'griddeletar',
            'rateio',
            'rateiovalor',
            'corfundo',
            'anexo',
          ];

          let raw = subformForm?.[key] ?? formData?.[key];
          let valor = isValid(raw) ? (formatData?.[key] ?? raw) : '';

          if (tipo === 'date' && valor) {
            const [day, month, year] = valor.split('/');
            valor = `${year}-${month}-${day}`;
          }

          const thisBlock = subformForm?.colblo?.includes(key);

          const thisTabIndex = Number(item?.posicao) + 900;

          if (abas?.length < 1 || chooseAba === '' || item.id === chooseAba) {
            if (!excludeKeys.includes(key) && item.mostrar != 'N') {
              return (
                <div
                  className={`tamanho${item.tamanho}`}
                  style={{ order: `${item.posicao}` }}
                  key={column.accessorKey}
                >
                  {defaultInput && (
                    <CustomInput
                      Class={item.obrigatorio === 'S' ? 'obr' : ''}
                      PlaceHolder={`${column.header} ${item.obrigatorio === 'S' ? '*' : ''} ${thisBlock ? '🔒' : ''}`}
                      Key={isAdm ? key : null}
                      Type={tipo}
                      Disabled={item.editavel === 'N' || thisBlock}
                      OnChange={(e) => {
                        if (tipo === 'date') {
                          setSubformForm((prev) => ({
                            ...prev,
                            [key]: formatData(e.target.value),
                          }));
                        } else {
                          setSubformForm((prev) => ({
                            ...prev,
                            [key]: e.target.value,
                          }));
                        }
                      }}
                      CorFundo={item.corfundo}
                      CorTexto={item.cortexto}
                      Color={item.corborda}
                      DefaultValue={valor}
                      TabIndex={item.editavel !== 'N' ? thisTabIndex : 999} //--------------
                    />
                  )}
                  {tipo === 'consulta' && (
                    <ConsultaInput
                      Class={
                        item.obrigatorio === 'S' && !isValid(subformForm[key])
                          ? 'obr'
                          : ''
                      }
                      PlaceHolder={`${column.header} ${item.obrigatorio === 'S' ? '*' : ''} ${thisBlock ? '🔒' : ''}`}
                      Key={isAdm ? key : null}
                      Type={tipo}
                      Disabled={item.editavel === 'N' || thisBlock}
                      OnPress={() => {
                        setConsultaData(item);
                        setConsultaTitulo(column.header);
                        setConsultaModal(true);
                      }}
                      CorFundo={item.corfundo}
                      CorTexto={item.cortexto}
                      Color={item.corborda}
                      DefaultValue={valor}
                      TabIndex={item.editavel !== 'N' ? thisTabIndex : 999} //--------------
                      OnChange={(e) => {
                        setSubformForm((prev) => ({
                          ...prev,
                          [key]: e.target.value,
                        }));
                      }}
                    />
                  )}
                  {tipo === 'select' && (
                    <SelectInput
                      Class={
                        item.obrigatorio === 'S' && !isValid(subformForm[key])
                          ? 'obr'
                          : ''
                      }
                      PlaceHolder={`${column.header} ${item.obrigatorio === 'S' ? '*' : ''} ${thisBlock ? '🔒' : ''}`}
                      Key={isAdm ? key : null}
                      Type={tipo}
                      Disabled={item.editavel === 'N' || thisBlock}
                      Options={item.options}
                      CorFundo={item.corfundo}
                      CorTexto={item.cortexto}
                      Color={item.corborda}
                      OnChange={(e) =>
                        setSubformForm((prev) => ({
                          ...prev,
                          [key]: e.target.value,
                        }))
                      }
                      DefaultValue={valor}
                      TabIndex={item.editavel !== 'N' ? thisTabIndex : 999} //--------------
                    />
                  )}
                  {tipo === 'select2' && (
                    <SelectInput2
                      Class={
                        item.obrigatorio === 'S' && !isValid(subformForm[key])
                          ? 'obr'
                          : ''
                      }
                      PlaceHolder={`${column.header} ${item.tipo} ${item.obrigatorio === 'S' ? '*' : ''} ${thisBlock ? '🔒' : ''}`}
                      Key={isAdm ? key : null}
                      Type={'select'}
                      OnChange={(e) => {
                        setSubformForm((prev) => ({
                          ...prev,
                          [key]: e.target.value,
                        }));
                      }}
                      Disabled={item.editavel === 'N' || thisBlock}
                      Options={item.options}
                      Filtro={item.origemFiltro.map((f) => subformForm[f])}
                      CorFundo={item.corfundo}
                      CorTexto={item.cortexto}
                      Color={item.corborda}
                      DefaultValue={valor}
                      TabIndex={item.editavel !== 'N' ? thisTabIndex : 999} //--------------
                    />
                  )}
                </div>
              );
            }
          }
          return null;
        });

        // se não tiver grupo, só retorna os itens
        if (grupo === '__semgrupo__') return groupContent;
        if (groupContent.filter(Boolean).length === 0) return null;

        return (
          <div
            key={`grupo-${grupo}`}
            className="grupoWrapper"
            style={{ order: '999' }}
          >
            <div
              className="grupoTitulo"
              style={{
                color: `${contrastColor}`,
                backgroundColor: `${corFundo}`,
              }}
            >
              {grupo}
            </div>
            {groupContent}
          </div>
        );
      })
    );
  }

  return (
    <div className="content subTableWrapper">
      {centroDeCustos && (
        <>
          <CentroDeCusto
            onClose={() => {
              setCentroDeCustos(false);
              setSelectedRateio(null);
            }}
            Title={titulo}
            blocked={blockReg}
            ordemCompra={formData.numocp}
            fornecedor={formData.nomfor}
            data={selectedRateio}
            saveFunction={HandleSaveRateio}
            origem={2}
          />
        </>
      )}

      {showWarning && (
        <div className="modal absoluteCenter consultaModal">
          <p>Tem certeza que deseja deletar este item?</p>
          <div className="list">
            <button
              className="mainButton red"
              onClick={() => setShowWarning(false)}
            >
              <End />
              Cancelar
            </button>
            <button
              className="mainButton turquoise"
              onClick={() => {
                HandleDelete(rowToDelete);
                setShowWarning(false);
              }}
            >
              <Check /> Deletar
            </button>
          </div>
        </div>
      )}

      <div
        className="newControls"
        style={{ backgroundColor: isValid(corFundo) ? corFundo : '#fff' }}
      >
        <span
          style={{ backgroundColor: isValid(corFundo) ? corFundo : '#fff' }}
        >
          <button
            className="icon popupButton cancelar"
            onClick={() => {
              showAdd ? setShowAdd(false) : HandleSave();
            }}
          >
            Retornar <GoBack />
          </button>

          <button
            className="icon popupButton salvar"
            onClick={() => {
              setShowAdd(true);
              setModo('add');
              setSelectedRow([]);
              setSubformForm([]);
            }}
            disabled={block || blockAdd}
          >
            {`Adicionar Item ${blockAdd ? '🔒' : ''}`}
            <SaveIcon />
          </button>
        </span>
      </div>

      {showAdd && (
        <>
          <button className="subFormFade" onClick={handleClose} />

          <div
            className={`modal absoluteCenter subFormConsulta ${formError ? 'erro' : ''}`}
            style={{ backgroundColor: isValid(corFundo) ? corFundo : '#fff' }}
          >
            {abas?.length > 0 && (
              <div className={`formTabs ${contrastColor}`}>
                {showAbaTodos && (
                  <button
                    className={`formTabItem ${chooseAba === '' ? 'active' : 'notActive'}`}
                    style={{
                      backgroundColor: isValid(corFundo) ? corFundo : 'inherit',
                      color: contrastColor,
                    }}
                    onClick={() => setChooseAba('')}
                  >
                    Todos
                  </button>
                )}

                {abas.map((item, index) => (
                  <button
                    key={index}
                    className={`formTabItem ${chooseAba === item ? 'active' : 'notActive'}`}
                    style={{
                      backgroundColor: isValid(corFundo) ? corFundo : 'inherit',
                      color: contrastColor,
                    }}
                    onClick={() => setChooseAba(item)}
                  >
                    {item}
                  </button>
                ))}
              </div>
            )}
            {isValid(abas) && (
              <div className={`listType ${contrastColor}`}>
                <button
                  className={showAbaTodos && 'active'}
                  onClick={() => {
                    if (!showAbaTodos) {
                      setShowAbaTodos(true);
                      setChooseAba('');
                    } else {
                      if (chooseAba === '')
                        setChooseAba(isValid(abas) && abas[0]);
                      setShowAbaTodos(false);
                    }
                  }}
                >
                  <label> Mostrar: Todos </label>
                  <ShowTodos />
                </button>
              </div>
            )}

            {modo === 'add' && (
              <h2 style={{ color: contrastColor }}>
                Adicionar item em {titulo}
                <hr />
              </h2>
            )}
            {modo === 'edit' && (
              <h2 style={{ color: contrastColor }}>
                Editar item de {titulo}
                <hr />
              </h2>
            )}

            <div className="inputs">
              <div className={`acoes`}>
                {isValid(acoes) &&
                  Object.entries(acoes || {}).map(([key, item]) => {
                    if (
                      abas?.length < 1 ||
                      chooseAba === '' ||
                      item.id === chooseAba
                    ) {
                      return (
                        <div
                          className={`acao tipo${item.tipo} ${thisBlock && 'disabled'}`}
                          key={key}
                          style={{ backgroundColor: item.corfundo }}
                        >
                          <button
                            onClick={() => HandleAcao(item)}
                            disabled={blockReg || thisBlock}
                          >
                            {!isValid(item.icone) && <Plug />}
                            {!isValid(item.icone) && <Plugged />}

                            {isValid(item.icone) && (
                              <img
                                src={item.icone}
                                onError={(e) => {
                                  e.currentTarget.src = DefIcon;
                                }}
                              />
                            )}
                          </button>
                          <span style={{ color: item.corfonte }}>
                            {item.tipo === 'botao'
                              ? item.nome
                              : subformForm[item.nome] || item.nome}
                          </span>
                          {isValid(subformForm[item.nome]) &&
                            item.tipo !== 'botao' && (
                              <label style={{ backgroundColor: item.corfundo }}>
                                {`${item.nome} ${thisBlock ? '🔒' : ''}`}
                              </label>
                            )}
                        </div>
                      );
                    }
                  })}
              </div>
              {buttons}
            </div>

            {formError && (
              <h5>
                Verifique se todos os items obrigatórios foram preenchidos
              </h5>
            )}

            <span className="row">
              <button className="mainButton red" onClick={handleClose}>
                Cancelar
              </button>

              {modo === 'add' && (
                <button
                  className="mainButton turquoise"
                  onClick={() => {
                    HandleAddItem();
                  }}
                  disabled={block}
                >
                  Adicionar
                </button>
              )}
              {modo === 'edit' && (
                <button
                  className="mainButton turquoise"
                  onClick={() => {
                    if (!block) HandleEditItem();
                  }}
                  disabled={block}
                >
                  Salvar
                </button>
              )}
            </span>
          </div>
        </>
      )}

      {(showLixeira || false) && (
        <>
          {/*<button
            className="subFormFade"
            onClick={() => setShowLixeira(false)}
          />*/}

          <div className="modal modaLixeira absoluteCenter">
            <LixeiraTable
              allData={lixeira}
              colunas={colunas}
              restoreFunction={HandleRestore}
              setLixeiraData={setLixeira}
              OnClose={() => setShowLixeira(false)}
              titulo={id}
            />

            <span className="row">
              <button
                className="mainButton turquoise"
                onClick={() => setShowLixeira(false)}
              >
                Retornar
              </button>
            </span>
          </div>
        </>
      )}

      {consultaAcao && (
        <>
          <button
            className="subFormFade"
            onClick={() => setConsultaAcao(false) /*handleClose*/}
          />
          <div className="modal absoluteCenter consultaModal">
            {acaoParametros &&
              Object.entries(acaoParametros).map(([key, item]) => {
                if (key != 'config')
                  return (
                    <CustomInput
                      Disabled={key in subformForm}
                      key={key}
                      PlaceHolder={item.nome}
                      DefaultValue={subformForm[key] || ''}
                      OnChange={(e) => {
                        setAcaoParametrosResult((prev) => ({
                          ...prev,
                          [key]: e.target.value,
                        }));
                      }}
                    />
                  );
              })}

            <div>
              <button
                onClick={() => setConsultaAcao(false)}
                className="mainButton red"
              >
                Retornar
              </button>
              <button
                onClick={() => HandleAcaoConsulta()}
                className="mainButton turquoise"
              >
                Avançar
              </button>
            </div>
          </div>
        </>
      )}

      {consultaModal && (
        <>
          <button
            className="subFormFade"
            style={{ zIndex: 10 }}
            onClick={() => setConsultaModal(false) /*handleClose*/}
          />

          <div className="modal absoluteCenter">
            <SearchTable
              webservice={consultaData}
              SetSearch={handleSetSearch}
              Titulo={consultaTitulo}
              onClose={() => setConsultaModal(false)}
              tabIndex={tabIndex}
              extraData={subformForm}
              extraExtraData={myData}
            />
          </div>
        </>
      )}

      <Box
        sx={{
          display: 'flex',
          height: '100%',
          width: '100%',
          position: 'relative',
          backgroundColor: isValid(corFundo) ? corFundo : '#fff',
        }}
      >
        <MaterialReactTable table={subFormTable} />
      </Box>
    </div>
  );
}

SubFormTable.propTypes = {
  colunas: PropTypes.object,
  tableData: PropTypes.array,
  myData: PropTypes.object,
  saveFunction: PropTypes.func,
  subformKey: PropTypes.string,
  OnClose: PropTypes.func,
  titulo: PropTypes.string,
  extraData: PropTypes.object,
  extraExtraData: PropTypes.object,
  id: PropTypes.string,
  tabIndex: PropTypes.number,
  corFundo: PropTypes.string,
  blockAdd: PropTypes.bool,
  formData: PropTypes.object,
};
